import './App.scss';

import React from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import FileUploadPageFormular from './Components/Pages/Formular/FileUploadPage';
import ReportPageFormular from './Components/Pages/Formular/ReportPage';
import FileUploadPageRechner from './Components/Pages/Rechner/FileUploadPage';
import ReportPageRechner from './Components/Pages/Rechner/ReportPager';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useAuth } from './Auth/KeycloakProvider';

const App = () => {
  const { authenticated, loading, login } = useAuth();

  return (
    <>
      <div className="page flex">
        {authenticated && !loading && (
          <React.Fragment>
            <BrowserRouter>
              <Header />
              <main>
                <Routes>
                  <Route path="/formular">
                    <Route
                      path="report"
                      element={<ReportPageFormular />}
                    />
                    <Route
                      path="upload"
                      element={<FileUploadPageFormular />}
                    />
                  </Route>
                  <Route path="/rechner">
                    <Route
                      path="report"
                      element={<ReportPageRechner />}
                    />
                    <Route
                      path="upload"
                      element={<FileUploadPageRechner />}
                    />
                  </Route>
                </Routes>
              </main>
            </BrowserRouter>
            <Footer />
          </React.Fragment>
        )}

        {!authenticated && !loading && (
          <div className="container d-flex flex-column justify-content-center align-items-center py-5">
            <h1 className="d-flex justify-content-center align-items-center text-center">
              Bitte logge dich ein, um den Bericht-Tool nutzen zu
              können.
            </h1>
            <div className="d-block">
              <button
                className="btn btn-primary"
                onClick={() => login()}
              >
                Einloggen
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default App;
